import {http} from '@/http'

export default {
  listDistricts() {
    return http.get('/ubigeos/districts')
  },
}
